import { ErrorHandler, NgModule } from '@angular/core';

import { ErrorsRoutingModule } from "./errors-routing.module";
import { ErrorsHandlerService } from "./services/errors-handler.service";
import { ErrorNotFoundComponent } from './components/error-not-found/error-not-found.component';
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {TokenInterceptor} from "../token-interceptor.service";

@NgModule({
  imports: [
      ErrorsRoutingModule
  ],
  declarations: [
      ErrorNotFoundComponent
  ],
  providers: [
    { provide: ErrorHandler, useClass: ErrorsHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ]
})
export class ErrorsModule { }
